import { render, staticRenderFns } from "./join-us.vue?vue&type=template&id=6a295656&"
import script from "./join-us.vue?vue&type=script&lang=js&"
export * from "./join-us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports